import { useContext, useEffect, useState } from "react";
import { SettingsContext, ShopContext, TableContext, UserContext } from "../App";
import "../css/MonoOrderConfirm.css";
import Label from "./Label";
import PickupTickets from "./PickupTickets";
import api from "./api/api";
import currencyFormat from "./functions/functions";
import { renderVariants, renderSubProducts } from "./functions/renderOrderVariants";

function MonoOrderConfirm({ onClose }) {
  const { settings, monoOrderConfirmVisible, history, setHistory, setLocalHistoryVisible, setOrdersVisible } =
    useContext(SettingsContext);
  const { shop } = useContext(ShopContext);
  const { table } = useContext(TableContext);
  const { user } = useContext(UserContext);
  const [order, setOrder] = useState(false);
  const ticketsActive = settings.selfordering.enable_pickup_receipts_mono == 1;
  const [recapExpanded, setRecapExpanded] = useState(!ticketsActive);

  useEffect(() => {
    if (monoOrderConfirmVisible.id) loadOrder();
  }, [monoOrderConfirmVisible]);

  async function loadOrder() {
    console.log("load_customer");
    const response = await api.post("/orders/get/" + monoOrderConfirmVisible.id + "/");
    if (response.success === 0) alert(response.error);
    setOrder(response.data);
    if (!history.find((o) => o.id == response.data.id)) {
      let newHistory = [response.data, ...history];
      if (newHistory.length > 10) newHistory = newHistory.slice(0, 10);
      setHistory(newHistory);
    }
  }

  return (
    <div
      className="mono-order-confirm"
      style={{
        backgroundColor: settings.selfordering.color1,
      }}
    >
      <div className="content">
        <h4>
          <Label number={140} />
        </h4>
        <span>
          <Label number={141} />
        </span>
        <h1>{order.number ? `N.${order.number} - ` : ""}ID:{monoOrderConfirmVisible.id}</h1>
        {table?.name && (
          <h4>
            {table?.room?.name && (
              <>
                <Label number={153} suffix=": " />
                {table.room.name} -{" "}
              </>
            )}
            <Label number={22} suffix=": " />
            {table.name}
          </h4>
        )}
        <img
          src={
            "https://api.yellgo.cloud/class/barcode.php?f=png&s=qr&p=0&w=500&h=500&d=" +
            monoOrderConfirmVisible.id
          }
        />
        <div className="recap">
          <div className="recap-header">
            <div
              className={"recap-header-title" + (ticketsActive ? " recap-toggle" : "")}
              onClick={ticketsActive ? () => setRecapExpanded((v) => !v) : undefined}
            >
              <strong>
                <Label number={148} />
              </strong>
              {ticketsActive && (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: 6, transform: recapExpanded ? "rotate(180deg)" : "none", transition: "transform .2s" }}>
                  <path d="m6 9 6 6 6-6"/>
                </svg>
              )}
            </div>
            <div className="recap-header-item">
              <div>
                <Label number={33} />: <strong>{order.name}</strong>
              </div>
              {order.email && (
                <div>
                  Email: <strong>{order.email}</strong>
                </div>
              )}
            </div>
          </div>
          {recapExpanded && (
            <div className="recap-products">
              {order.products &&
                order.products.map((product, index) => {
                  return (
                    <div className="recap-product" key={index}>
                      <div className="recap-product-name">
                        {product.name}
                        {renderVariants(product.variants)}
                        {renderSubProducts(product.products)}
                      </div>
                      <div className="recap-product-quantity">{product.qty}</div>
                      <div className="recap-product-price">
                        {currencyFormat(product.price, false, shop.currency)}
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
          <div className="total">
            <span>Totale:</span> {currencyFormat(order.total, false, order.currency)}
          </div>
        </div>

        {settings.selfordering.enable_pickup_receipts_mono == 1 && monoOrderConfirmVisible.id && (
          <PickupTickets orderId={monoOrderConfirmVisible.id} />
        )}

        <button
          onClick={onClose}
          className="button"
          style={{
            backgroundColor: settings.selfordering.color1,
            color: settings.selfordering.color2,
          }}
        >
          <Label number={142} />
        </button>
        <button
          className="button"
          onClick={() => {
            onClose();
            setLocalHistoryVisible(true);
          }}
          style={{
            backgroundColor: settings.selfordering.color1,
            color: settings.selfordering.color2,
            marginTop: "10px",
          }}
        >
          <Label number={121} />
        </button>
      </div>
    </div>
  );
}

export default MonoOrderConfirm;
